import { RootState } from 'app/store';
import ExportButton from 'common/components/buttons/exportButton';
import SearchBar from 'features/search-bar/searchBar';
import {
  applySearchToTableAndGraph,
  clearSearch,
  getSearchTermsById
} from 'features/search-bar/searchBarSlice';
import { FC } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { ViewType } from 'features/data-view-selection/view-type';

const ConversionsInteractionBar: FC<{
  componentId: string;
  currentViewType: ViewType;
  isExporting: boolean;
  onChangeViewType: (viewType: ViewType) => void;
  onTriggerExport: () => void;
}> = ({
  componentId,
  currentViewType,
  isExporting,
  onChangeViewType,
  onTriggerExport
}) => {
  const dispatch = useDispatch();

  const { tableValueToSearch } = useSelector((state: RootState) =>
    getSearchTermsById(state, componentId)
  );

  const toggleViewType = (viewType: ViewType) => {
    onChangeViewType(viewType);
  };

  return (
    <>
      <div className="flex items-center justify-between flex-wrap pb-2 w-full">
        <SearchBar
          searchValue={tableValueToSearch}
          onClickFunction={(searchTerm: string) => {
            dispatch(
              applySearchToTableAndGraph({
                id: componentId,
                valueToSearch: searchTerm
              })
            );
          }}
          onClearFunction={() => {
            dispatch(
              clearSearch({
                id: componentId
              })
            );
          }}
        />
        <div className="flex align-middle">
          <ExportButton
            onExport={(): any => (isExporting ? null : onTriggerExport())}
            isLoading={isExporting}
          />
          <button
            className={`border rounded border-off-navy ml-3 text-sm py-2.5 px-5 text-center ${
              currentViewType === ViewType.Simple
                ? 'bg-navy text-white'
                : 'bg-white text-black'
            } `}
            onClick={() => toggleViewType(ViewType.Simple)}
          >
            Simple
          </button>
          <button
            className={`border rounded border-off-navy ml-3 text-sm py-2.5 px-5 text-center ${
              currentViewType === ViewType.Detailed
                ? 'bg-navy text-white'
                : 'bg-white text-black'
            } `}
            onClick={() => toggleViewType(ViewType.Detailed)}
          >
            Detailed
          </button>
        </div>
      </div>
    </>
  );
};

export default ConversionsInteractionBar;
